import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import {
  type GetCalenderReq,
  type GetEarnedHistoryReq,
  type GetTrendReq,
  getCalender,
  getEarnedHistory,
  getEarnedPoints,
  getPendingPointSchedule,
  getTrend,
} from './mapper';

export const viewingMoneyQueryKey = createQueryKeys('viewingMoney', {
  calender: (params: GetCalenderReq) => ({
    queryFn: async () => {
      const data = await getCalender(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
  earnedHistory: (params: GetEarnedHistoryReq) => ({
    queryFn: async () => {
      const data = await getEarnedHistory(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
  earnedPoints: {
    queryFn: async () => {
      const data = await getEarnedPoints();
      return data;
    },
    queryKey: null,
  },
  pendingPointSchedule: {
    queryFn: async () => {
      const data = await getPendingPointSchedule();
      return data;
    },
    queryKey: null,
  },
  trend: (params: GetTrendReq) => ({
    queryFn: async () => {
      const data = await getTrend(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
});

export type ViewingMoneyQueryKey = inferQueryKeys<typeof viewingMoneyQueryKey>;
